import { Injectable } from '@angular/core';

@Injectable()
export class RecipeListCommon {
	
	constructor(
		
	) {

	}

	public commonMethod(){
		console.log("Hello");
	}
}



// WEBPACK FOOTER //
// ./src/modules/recipes/pages/recipe-list/recipe-list.common.ts